const DescAgence = () => {
    return(
        <div className="descriptif min-[320px]:py-8 xl:py-32 min-[320px]:pr-4 xl:pr-8 xl:ml-8 min-[320px]:pl-4">
            <div className="descriptif-txt flex">
                <div className="descriptif-txt-1">
                    <h1>L'agence<span>,</span></h1>
                    <p>
                        accompagne les entreprises dans la création de contenus photo et vidéo pensés pour valoriser leur image et raconter leur histoire.<br/><br/>
                        Plus qu’une société de production, l’agence se positionne comme un véritable partenaire créatif, en imaginant des contenus sur-mesure alignés avec les objectifs, l’identité et les enjeux de chaque marque.<br/><br/>
                        Basée entre Bordeaux et Paris, Agence Le Menu intervient partout en France et à l’international avec une approche à la fois humaine, agile et exigeante.<br/>
                    </p>
                </div>

                <div className="descriptif-txt-2 self-end">
                    <h2>Les expertises<span>.</span></h2>
                    <p>
                        Film corporate, couverture événementielle, reportage photo, interview, contenus réseaux sociaux, motion design ou captation drone : l’agence développe des formats créatifs et impactants adaptés à chaque projet.<br/><br/>
                        Nous intègrons également les technologies innovantes comme l’intelligence artificielle, les contenus immersifs ou les expériences en temps réel afin de proposer des productions modernes, engageantes et pensées pour marquer les esprits.<br/>
                    </p>
                    <div className="round-bg"></div>
                </div>
            </div>
        </div>
    )
}
export default DescAgence;